<template>
  <div class="flex items-center gap-3 p-3 border-b animate-pulse">
    <div class="flex-shrink-0 w-12 h-12 bg-slate-200 rounded-full"></div>
    <div class="flex-1 min-w-0 flex flex-col gap-2">
      <div class="h-4 bg-slate-200 rounded w-3/4"></div>
      <div class="h-3 bg-slate-200 rounded w-20"></div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
